import axios from "../helper/axios";
import { apiUrl, fileUploadUrl } from "../config/config";
export async function getProduct(tag) {
  try {
    let res = await axios.Get({
      url: `${apiUrl}/packages?tag=${tag}`
    });

    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return {error:e};
    }
  }
}
export async function getBank() {
  try {
    let res = await axios.Get({
      url: `${apiUrl}/banks`
    });

    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return {error:e};
    }
  }
}
export async function orderNewWallet({
  packageCode
}) {
  try {
    let res = await axios.Post({
      url: `${apiUrl}/wallet/order-new`,
      data: {
        packageCode: packageCode
      }
    });
    
    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return {error:e};
    }
  }
}
export async function activateWallet(postData) {
  try {
    let res = await axios.Post({
      url: `${apiUrl}/wallet/activate`,
      data: postData
    });
    
    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return {error:e};
    }
  }
}
export async function postPersonalInfo(postData) {
  try {
    let res = await axios.Post({
      url: `${apiUrl}/user/set-personal-info`,
      data: postData
    });
    
    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return {error:e};
    }
  }
}
export async function getFilenamePHOTOConfig(filename) {
  try {
    let res = await axios.GetWithAuth({
      url: `${fileUploadUrl}/user/upload/photo-id-card/get-url?filename=${filename}`
    });
    
    if (res.error) {
      return { error: res.error };
    }

    return { data: res.filename };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return {error:e};
    }
  }
}
export async function getFilenameIDCARDConfig(filename) {
  try {
    let res = await axios.GetWithAuth({
      url: `${fileUploadUrl}/user/upload/id-card/get-url?filename=${filename}`
    });
    
    if (res.error) {
      return { error: res.error };
    }

    return { data: res.filename };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return {error:e};
    }
  }
}

export async function postFinalizeRegistration(postData) {
  try {
    let res = await axios.Post({
      url: `${apiUrl}/user/finalize-registration`,
      data: postData
    });
    
    if (res.error) {
      return { error: res.error };
    }

    return { data: res.data };
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        return { error: e.response.data.error };
      } else {
        return { error: e.message };
      }
    } else {
      return {error:e};
    }
    
  }
}